import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.data ? _c('div', [_c('details-block', {
    attrs: {
      "title": _vm.t('基本信息')
    }
  }, [_c('details-field', {
    attrs: {
      "label": _vm.t('充值单号'),
      "content": _vm._f("filterEmpty")(_vm.data.order_number)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('账户编码'),
      "content": _vm._f("filterEmpty")(_vm.data.account_code)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('签约业务'),
      "content": _vm._f("filterEmpty")(_vm.data.sign_business_type_list_text)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('交易状态'),
      "content": _vm._f("filterEmpty")(_vm.data.transaction_status_text)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('交易方式'),
      "content": _vm._f("filterEmpty")(_vm.data.transaction_type_text)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('签约主体'),
      "content": _vm._f("filterEmpty")(_vm.data.sign_body_name)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('服务主体'),
      "content": _vm._f("filterEmpty")(_vm.data.service_body_name)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('客户代码'),
      "content": _vm._f("filterEmpty")(_vm.data.customer_code)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('充值时间'),
      "content": _vm._f("filterEmpty")(_vm.data.add_time)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('到账时间'),
      "content": _vm._f("filterEmpty")(_vm.data.payee_time)
    }
  })], 1), _c('details-block', {
    staticClass: "mt-15",
    attrs: {
      "title": _vm.t('付款信息')
    }
  }, [_c('details-field', {
    attrs: {
      "label": _vm.t('付款银行'),
      "content": _vm._f("filterEmpty")(_vm.data.bank_name)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('付款账号名'),
      "content": _vm._f("filterEmpty")(_vm.data.drawee)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('付款方账号'),
      "content": _vm._f("filterEmpty")(_vm.data.drawee_account)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('是否第三方平台'),
      "content": _vm._f("filterEmpty")(_vm.data.third_party_payment_platform_text)
    }
  })], 1), _c('details-block', {
    staticClass: "mt-15",
    attrs: {
      "title": _vm.t('收款信息')
    }
  }, [_c('details-field', {
    attrs: {
      "label": _vm.t('收款人名称'),
      "content": _vm._f("filterEmpty")(_vm.data.payee_name)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('开户行'),
      "content": _vm._f("filterEmpty")(_vm.data.payee_bank_name)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('收款人账号'),
      "content": _vm._f("filterEmpty")(_vm.data.payee_account)
    }
  })], 1), _c('details-block', {
    staticClass: "mt-15",
    attrs: {
      "title": _vm.t('充值信息')
    }
  }, [_c('details-field', {
    attrs: {
      "label": _vm.t('转账币种'),
      "content": _vm._f("filterEmpty")(_vm.data.currency_code)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('转账金额'),
      "content": _vm._f("filterEmpty")(_vm.data.register_amount)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('转汇汇率'),
      "content": _vm._f("filterEmpty")(_vm.data.exchange)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('银行流水号/代金券卡号'),
      "content": _vm._f("filterEmpty")(_vm.data.reference_number)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('到账币种'),
      "content": _vm._f("filterEmpty")(_vm.data.recharge_code)
    }
  }), _c('details-field', {
    attrs: {
      "label": _vm.t('到账金额'),
      "content": _vm._f("filterEmpty")(_vm.data.arrival_amount)
    }
  })], 1), _vm.data.file_path ? _c('div', [_c('div', {
    staticClass: "most-big-title mt-15 mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('附件')))])]), _c('a', {
    attrs: {
      "href": _vm.data.file_path,
      "target": "_blank",
      "fbu-analyse-name": $t("\u94F6\u884C\u56DE\u6267\u6D41\u6C34\u5355")
    }
  }, [_vm._v(_vm._s(_vm.t('银行回执流水单')))])]) : _vm._e()], 1) : _c('a-skeleton', {
    attrs: {
      "active": ""
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };